/**
 * Shape of the GET /v1/config response from the pipeline.
 * Mirrors src/pdtf_doc_pipeline/api/config_router.py.
 */
export interface AppConfig {
  roles: string[];
  featureFlags: Record<string, unknown>;
  urls: {
    httpBase: string;
    wsBase: string;
    blobCdn: string;
  };
  locale: string;
  version: string;
  principal: {
    subject: string;
    kind: 'user' | 'service';
    tenantId: string | null;
  };
}

/** Empty config used as the pre-init default. */
export const EMPTY_APP_CONFIG: AppConfig = {
  roles: [],
  featureFlags: {},
  urls: { httpBase: '', wsBase: '', blobCdn: '' },
  locale: 'en-GB',
  version: '0.0.0-unknown',
  principal: { subject: '', kind: 'user', tenantId: null },
};
